import React, { useCallback } from 'react';
import Navbar from '../components/Header/Navbar';
import Footer from '../components/Footer';
import PolicyContainer from '../components/Policy/PolicyContainer';
import { policyService } from '../api';

const KullaniciSozlesmesi: React.FC = () => {
  const fetchPolicy = useCallback(async () => {
    const result = await policyService.getTermsOfService();
    return result.isSuccess && result.data ? result.data : null;
  }, []);

  return (
    <div className="sb-page-bg min-vh-100 d-flex flex-column">
      <Navbar />
      <main className="container py-4 flex-grow-1">
        <PolicyContainer
          fetchPolicy={fetchPolicy}
          fallbackTitle="Kullanıcı Sözleşmesi"
        />
      </main>
      <Footer />
    </div>
  );
};

export default KullaniciSozlesmesi;
